export default "__VITE_ASSET__BaH1HUuw__"